










import Auth from "front-component/Auth";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ShowUserAdmin extends Vue {

    private get adminUser(): string | null {
        return localStorage.getItem("admin_user");
    }
    private backToAdminUser(): void {
        const adminToken = localStorage.getItem("access_token_admin");
        if (adminToken) {
            localStorage.setItem("access_token_admin", "");
            Auth.setAccessToken(adminToken);
            location.reload();
        }
    }
}
